<script lang="ts">
	import heroPhotoMobile from "@assets/final_photos/DSC_0189.jpg?webp&w=768&imagetools";
	import heroPhoto from "@assets/final_photos/DSC_0189.jpg?webp&w=1440&imagetools";
	import ContactCards from "@components/ContactCards.svelte";
	import ContactForm from "@components/ContactForm.svelte";
	import PageHero from "@components/PageHero.svelte";
	import WhereYouCanFindUs from "@components/WhereYouCanFindUs.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { contactId } from "@core/schema/ids/contactId.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Contact.translations.json" with { type: "json" };
	import type { ContactProps } from "./ContactProps.js";

	const { contacts }: ContactProps = $props();
	const translate = getTranslate(translations);
</script>

<Layout>
	<PageHero
		image={heroPhoto}
		mobileImage={heroPhotoMobile}
		alt={translate("heroAlt")}
		heading={translate("heroHeading")}
		text={translate("heroText")}
		buttonText={translate("heroButtonText")}
		customIdHref={contactId}
	/>
	<WhereYouCanFindUs />
	<ContactCards {contacts} />
	<ContactForm heading="withText" />
</Layout>
